module.exports = __webpack_public_path__ + "static/media/Radha.0c621f1e.jpeg";